import { TFunction } from 'i18next';
import { ReactNode } from 'react';
import { translatePartOfStringWithLink } from '../../../lib/StringUtils/StringHTMLUtils';

/**
 * Translations of SonResponseErrorTypes.
 */
export function getDefaultErrorTypeTranslations(t: TFunction<'translation', undefined>, response: any): ReactNode {
  switch (response.errorType) {
    case 'invalidValue':
      return t('Form:errorType.invalidValue');
    case 'duplicateId':
      return t('Form:errorType.duplicateId');
    case 'maxUploadSizeExceeded':
      return t('Form:errorType.maxUploadSizeExceeded');
    case 'invalidVersionState':
      return t('Form:errorType.invalidVersionState');
    case 'expiredSessionOrCsrf':
      return t('Form:errorType.expiredSessionOrCsrf');
    case 'itemAlreadyExists':
      return t('Form:errorType.itemAlreadyExists');
    case 'payloadError':
      return t('Form:errorType.payloadError');
    case 'surveyInProgress':
      return t('Form:errorType.surveyInProgress');
    case 'pageLocked':
      return translatePartOfStringWithLink('Form:errorType.pageLocked', response.pageLockedBy.url, false, {
        name: response.pageLockedBy.name,
      });
    default:
      return response.errorType;
  }
}
